export const expandText = () => {
    const cards = document.querySelectorAll('.expandable-card');

    // @ts-ignore
    const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
            const textElement = entry.target as HTMLDivElement;
            
            const card = textElement.closest('.expandable-card');
            if (!card) continue;
            
            const showMoreBtn = card.querySelector('.show-more-btn') as HTMLButtonElement | null;
            const showLessBtn = card.querySelector('.show-less-btn') as HTMLButtonElement | null;
            
            if (!showMoreBtn || !showLessBtn) continue;

            let isCurrentlyExpanded = textElement.classList.contains('expanded');
            if (isCurrentlyExpanded) {
                textElement.classList.remove('expanded');
            }

            const isOverflowing = textElement.scrollHeight > textElement.clientHeight;

            if (!isOverflowing) {
                showMoreBtn.classList.add('hidden-button');
                showLessBtn.classList.add('hidden-button');
                isCurrentlyExpanded = false; 
            } else {
                if (isCurrentlyExpanded) {
                    showMoreBtn.classList.add('hidden-button');
                    showLessBtn.classList.remove('hidden-button');
                } else {
                    showMoreBtn.classList.remove('hidden-button');
                    showLessBtn.classList.add('hidden-button');
                }
            }

            if (isCurrentlyExpanded) {
                textElement.classList.add('expanded');
            }
        }
    });

    cards.forEach(card => {
        const textElement = card.querySelector('.text-content') as HTMLDivElement | null;
        const iconlistInExpandedWrapper = card.querySelector('.iconlist-in-expanded-wrapper') as HTMLDivElement | null;
        const showMoreBtn = card.querySelector('.show-more-btn') as HTMLButtonElement | null;
        const showLessBtn = card.querySelector('.show-less-btn') as HTMLButtonElement | null;

        if (textElement && showMoreBtn && showLessBtn) {
            resizeObserver.observe(textElement);

            const handleToggle = () => {
                const isExpanded = textElement.classList.toggle('expanded');

                if (iconlistInExpandedWrapper) {
                    iconlistInExpandedWrapper.classList.toggle('expanded');
                }
                
                if (isExpanded) {
                    showMoreBtn.classList.add('hidden-button');
                    showLessBtn.classList.remove('hidden-button');
                } else {
                    showMoreBtn.classList.remove('hidden-button');
                    showLessBtn.classList.add('hidden-button');
                }
            };

            showMoreBtn.addEventListener('click', handleToggle);
            showLessBtn.addEventListener('click', handleToggle);
        }
    });
}